import BaseModelAPI from '../BaseModelAPI';

export default class ApprovalInstanceList extends BaseModelAPI {

	static entity = 'approvalinstancelist'
	static entityName = 'approvalinstance';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
